export default __webpack_public_path__ + "static/c05-8cae9ee152c7be58c3e58e5c9b42cfa3.png";